import { Injectable } from '@angular/core';
import { UnitesClientService } from '../../../../core/services/unites-client.service';
import { Observable, map } from 'rxjs';
import { Unites } from './unites.model';
import { IUnites } from '../../../../core/models/unites.model';
import { InlineResponse } from '../../../../core/models/inline-response.model';

@Injectable({
  providedIn: 'root',
})
export class ReferentialsUnitsService {
  constructor(private unitesClientService: UnitesClientService) {}

  getUnitesData(): Observable<Unites[]> {
    return this.unitesClientService.getUnitesData().pipe(
      map((unites) => unites.rows),
      map((rows) => rows.map((row) => new Unites(row.codeCourt, row.codeHecate, row.designation, row.id))),
    );
  }

  addUnitesData(codeCourt: string, codeHecate: number, designation: string): Observable<InlineResponse> {
    return this.unitesClientService.addUnitesData(codeCourt, codeHecate, designation);
  }

  updateUnitesData(unites: Unites): Observable<InlineResponse> {
    return this.unitesClientService.updateUnitesData(unites);
  }
}
